const initialState = {};

const _transformData = (data) => {
  const processDeep = (rows, parentId = undefined, level = 0, code = '') => {
    return _.map(rows, (row, i) => {
      const id = parentId ? [parentId, row.id].join('-') : _.toString(row.id);
      const new_code = code.length == 0 ? i + 1 : `${code}.${i + 1}`;

      return {
        ...row,
        code: level < 4 ? new_code : undefined,
        level,
        id,
        parentId,
        ownId: row.id,
        children: row.children
          ? processDeep(
              _.sortBy(row.children, 'order'),
              id,
              level + 1,
              new_code
            )
          : [],
      };
    });
  };

  const transformed_data = processDeep(_.sortBy(data, 'order'));

  return transformed_data;
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.stages/SET_TABLE_PARAMS':
      return {
        ...state,
        ...action.params,
      };
    case 'table.stages/LIST_PROJECT_STAGES_SUCCESS':
      return {
        ...state,
        data: action.response.data,
        filters: action.response.filters,
        ...action.response.pagination,
      };
    case 'table.stages/READ_STAGE_SUCCESS':
      return {
        ...state,
        flyout: action.response.data,
      };

    case 'table.stages/LIST_PROJECT_SUBSTAGES_SUCCESS':
    case 'table.stages/LIST_PROJECT_SUBSTAGES_SCHEDULE_SUCCESS':
      return {
        ...state,
        substages: _transformData(action.response.data),
      };
    default:
      return state;
  }
}
